import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
// import { ShapeOptions , CircleProgressComponent,SemiCircleProgressComponent} from 'angular2-progressbar';
import { Observable, Subscription } from 'rxjs/Rx';
import { environment } from '../../../';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { CookieManagerService, ErrorManagerService, HttpClientService, BasicTimerService, CustomObserverService } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { PaperPart, OnlinePaper } from '../../model';
import { CookieNames, BasicRoutes, CircleUIOptions, ApiEndpoints, OnlineStatus } from '../../constant';

@Component({
  selector: 'app-paper-parts',
  templateUrl: '../views/paper-parts.component.html',
  styleUrls: ['../../../css/paper-parts.component.css', '../../../css/paper-sets.component.css'],
})
export class PaperPartsComponent implements OnInit, OnDestroy {

  // @ViewChild(CircleProgressComponent) circleComp: CircleProgressComponent;

  public paperPartObj: PaperPart = new PaperPart();
  public papersPaperUrl: string = BasicRoutes.clientPapersPaper;
  public setid: string;
  public paperid: string;
  public paperParts: Array<PaperPart> = [];
  public getMarks: any = [];
  public paperStats: any = {};
  public allMarks: any = 0;
  public papers: Object = this.cookieManagerService.getCookie(CookieNames.paperSetKey, false);
  public paperTitle;
  public emptyQustionPaperParts: boolean = false;
  public online: any = OnlineStatus.NOTONLINE;
  public countDownSubscrib: Subscription;
  public isOnlinePaperIncompleted : boolean = false;

  constructor(private route: ActivatedRoute,
    private _location: Location,
    private localSt: LocalStorageService,
    private basicTimerService: BasicTimerService,
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private router: Router,
    private translateService: TranslateService,
    private customObserverService: CustomObserverService)
  { }

  // private circleOptions: ShapeOptions = {
  //   color: CircleUIOptions.fillColor,
  //   trailColor: CircleUIOptions.trailColor,
  //   trailWidth: CircleUIOptions.trailWidth,
  //   duration: CircleUIOptions.duration,
  //   easing: CircleUIOptions.easing,
  //   strokeWidth: CircleUIOptions.strokeWidth,
  //   from: { color: CircleUIOptions.fillColor, a: 0 },
  //   to: { color: CircleUIOptions.baseColor, a: 1 },
  //   // Set default step function for all animate calls
  //   step: function(state: any, circle: any) {
  //     circle.path.setAttribute(CircleUIOptions.theme, CircleUIOptions.fillColor);
  //   }
  // };

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.paperid = params['paperid'];
    });
    this.cookieManagerService.setCookie(CookieNames.paperStartStatus, 'false', false, 1);
    this.cookieManagerService.setCookie(CookieNames.paperId, this.paperid, false, 1);
    this.getPaperStats();
    this.getPaperPartsInPaper();
    let papertitle = this.cookieManagerService.getCookie(CookieNames.paperTitle, false);
    this.paperTitle = papertitle ? papertitle : this.translateService.instant('ONLINE_EXAM');
    this.online = this.cookieManagerService.getCookie(CookieNames.onlineExam, false);
    let items = Object.keys(localStorage);
    items.map(item => {
      let isStart = item.startsWith('question-');
      isStart ? localStorage.removeItem(item) : false;
    })
   // document.body.scrollTop = 0;
    window.scrollTo(0, 0);
  }

  getMarksObj(part) {
    let returnObj = {
      id: 0,
      imageUrl: '/assets/img/status-new.svg',
      class: 'available',
      logoClass: 'status-new'
    };

    if (part.clientStatus == OnlineStatus.INPROGRESS) {
      returnObj.imageUrl = '/assets/img/status-completed.svg';
      returnObj.class = 'ongoing';
      returnObj.logoClass = 'status-ongoing';
    } else if (part.clientStatus == OnlineStatus.COMPLETE) {
      returnObj.imageUrl = '/assets/img/status-completed.svg';
      returnObj.class = 'completed';
      returnObj.logoClass = 'status-completed';
    }
    this.getMarks.push(returnObj);

  }

  /**
   * Get paper parts
   */
  getPaperPartsInPaper() {
    let that = this;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperParts, {
      [ApiEndpoints.paperid]: this.paperid
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      if (response.paperPart) {
        response.paperPart.forEach(part => {
          this.paperParts.push(new PaperPart(part));
          if (part.paperPartId == '2') {
            this.newTimeCounter(new PaperPart(part));
          }
        });
        this.paperParts = this.sortpaperParts(this.paperParts);
      }
      if (this.paperParts.length == 0) {
        this.emptyQustionPaperParts = true;
      }
      this.paperParts.forEach(function (mark) {
        that.getMarksObj(mark);
      });
    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }

  sortpaperParts(parts){
    parts.sort((a: any, b: any) => {
      return a.paperPartId- b.paperPartId;
    });
    return parts;
  }

  /**
   * Get paper sets statics
   */
  getPaperStats() {
    if (this.online == OnlineStatus.ONLINE) {
      return;
    }
    
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperPartsStatics, {
      [ApiEndpoints.paperid]: this.paperid
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      this.paperStats = response;
      if (this.paperStats.average !== undefined) {
        // this.circleComp.animate(this.paperStats.average/100);
      }
      if (response.average) {
        this.allMarks = response.average;
      }
    });
  }

  changeWidthOfProgressBar(width: number) {
    return width;
  }

  goToQuection(paperPart) {
    this.basicTimerService.examReloadReset();
    this.localSt.clear();
    localStorage.removeItem('lastQuection');
    this.customObserverService.hideNewsAlert({ isOnGoing: true, isShow: false });
    this.cookieManagerService.setCookie(CookieNames.paperPartNumber, paperPart.paperPartId, false, 1);
    
    this.cookieManagerService.setCookie(CookieNames.paperPartId, paperPart._id, false, 1); 
    let _id = paperPart.isClone ? paperPart.cloneParentObj : paperPart._id;
    this.router.navigate(['/home/exams/papers/parts/' + _id + '/questions']);
  }

  goBack() {
    if (this.online != OnlineStatus.ONLINE) {
      this.router.navigate(['/home/exams/' + this.papers + '/papers']);
    } else {
      this.router.navigate([BasicRoutes.clientExams]);
    }
  }

  backClicked() {
    if (this.online != OnlineStatus.ONLINE) {
      this.router.navigate(['/home/exams/' + this.papers + '/papers']);
    } else {
      this.router.navigate([BasicRoutes.onlinePapers]);
    }
  }

  private onlinePaper: OnlinePaper = new OnlinePaper();
  private perfNowStart = performance.now();

  newTimeCounter(part) {
    this.onlinePaper.currentTime = new Date(part.currentTime);
    this.onlinePaper.leftSeconds = this.dateTimeDiff(new Date(part.startAt));
    this.onlinePaper.timeInterval = setInterval(() => {
      this.onlinePaper.currentTime.setSeconds(this.onlinePaper.currentTime.getSeconds() + 1);
      this.timeDiff_performanceNow(this.onlinePaper.leftSeconds, this.perfNowStart, part);
    }, 1000)
  }

  z(n) { return (n < 10 ? '0' : '') + n; }

  timeDiff_performanceNow(target, clientStart, part: any) {
    let distance = target - performance.now() + clientStart
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (hours < 0 || minutes < 0 || seconds < 0) {
      let isEndAt = this.dateTimeDiff(new Date(part.endAt)) >= 0;
      let isBlockAt = this.dateTimeDiff(new Date(part.blockAt)) >= 0;
      if ( isEndAt && isBlockAt && part.clientStatus != OnlineStatus.COMPLETE) {
        this.onlinePaper.title = this.translateService.instant(OnlineStatus.START_SECOND.title1) + part.nextBlockTimeRange +this.translateService.instant(OnlineStatus.START_SECOND.title2);
        this.onlinePaper.canAccessPaper = true;
        this.onlinePaper.type = OnlineStatus.START_SECOND.discription;
        this.isOnlinePaperIncompleted = false;
      }
      else {
        this.onlinePaper.canAccessPaper = false;
        this.isOnlinePaperIncompleted = true;
        if(!isEndAt){
          this.onlinePaper.title = this.translateService.instant(OnlineStatus.NOTDONE.title);
        }
        if(isEndAt && !isBlockAt){
          this.onlinePaper.title = this.translateService.instant(OnlineStatus.BLOCK.title);
        }
      }
    }
    else {
      this.isOnlinePaperIncompleted = false;
      this.onlinePaper.canAccessPaper = false;
      this.onlinePaper.type = OnlineStatus.NOTSTART.discription;
      this.onlinePaper.minite = this.z(hours) + ':' + this.z(minutes) + ':' + this.z(seconds);
    }
  }

  dateTimeDiff(target: Date): number {
    return (target.getTime() - this.onlinePaper.currentTime.getTime());
  }

  ngOnDestroy() {
    if (this.onlinePaper.timeInterval) {
      clearInterval(this.onlinePaper.timeInterval);
    }
  }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/components/paper-parts.component.ts